export default class ShipPartRepoStatic {
  getConfigurationChilds(
    ship,
    configurationID,
    service,
    collectionConfigurationChild
  ) {
    const obj = {
      id:
        collectionConfigurationChild +
        "_" +
        ship.id +
        "-" +
        configurationID +
        "_1",
      type: collectionConfigurationChild,
      data: { a: 1 },
    };
    service.addNewShipPartFromRepo(
      ship,
      configurationID,
      collectionConfigurationChild,
      obj.id,
      obj
    );

    const obj2 = {
      id:
        collectionConfigurationChild +
        "_" +
        ship.id +
        "-" +
        configurationID +
        "_1",
      type: collectionConfigurationChild,
      data: { a: 1 },
    };
    service.addNewShipPartFromRepo(
      ship,
      configurationID,
      collectionConfigurationChild,
      obj2.id,
      obj2
    );
  }
}
